<template>
  <div style="height: 100%">
    <sys-menu ref="sysMenu"></sys-menu>
    <center id="center">
      <top v-on:child-say="listenMore" ref="top"></top>
      <!-- <router-view
      ></router-view> -->
      <template v-if="platConfig != null">
        <keep-alive
          ><router-view v-if="$route.meta.keepAlive"> </router-view
        ></keep-alive>
        <router-view v-if="!$route.meta.keepAlive"> </router-view>
      </template>

      <!-- https://segmentfault.com/a/1190000022829758 -->
      <!-- inlcude包含该组件就缓存，exclude不包含该组件就缓存，二者都可以用逗号分隔字符串、正则表达式或一个数组来表示 -->
    </center>
  </div>
</template>
<script>
import axios from "axios";
import sysMenu from "../../node_modules/common/src/components/sys/sysMenu.vue";
import top from "../../node_modules/common/src/components/sys/top.vue";
var webSet; //心跳定时器

let first = true; //第一次推送标志

var websock = null;
export default {
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      platConfig: null,
      deviceIdList: [],
      locateData: [],
      leftLoteData: {},
      leftStatue: {},
      isNoweb: false,
      histroyVideoData: [],
    };
  },
  components: {
    sysMenu,
    top,
  },
  methods: {
    listenMore(t) {
      this.more = t;
    },
    reload() {
      this.isShow = false;
      this.$nextTick(function () {
        this.isShow = true;
      });
    },
    reLiink() {
      this.isNoweb = false;
      this.localSocket();
      this.linkNum += 1;
    },
    //websock
    localSocket() {
      var json = JSON.parse(localStorage.getItem("Authorization"));
      var path =
        axios.imUrl +
        "?identityId=" +
        json.identityId +
        "&token=" +
        json.token +
        "&share=" +
        json.share;
      let that = this;
      if ("WebSocket" in window) {
        // console.log("您的浏览器支持 WebSocket!");
        // location.host
        that.ws = new WebSocket(path);
        that.utils.setWs(that.ws);

        that.ws.onopen = function () {
          console.log("websocket连接成功");
          webSet = setInterval(() => {
            // 构建对象
            var msg123 = {
              type: 4,
              data: "active",
            };
            // 发送心跳
            that.utils.ws.send(JSON.stringify(msg123));
          }, 15000);
        };

        that.ws.onclose = function () {
          // 关闭 websocket
          console.log("连接已关闭...");
          that.isNoweb = true;
          clearInterval(webSet);
        };
      } else {
        // 浏览器不支持 WebSocket
        console.log("您的浏览器不支持 WebSocket!");
      }
    },
    getProperty() {
      axios({
        method: "post",
        url: axios.oss + "/property/select",
        data: {},
      }).then((res) => {
        var data = res.data.data;
        axios.mapConfig = data.customProperty;
        //axios.platConfig.mapRefresh
        //sessionStorage.setItem(axios.plat + "123", JSON.stringify(data));
        axios.platConfig = data.publicProperty;
        this.platConfig = data.publicProperty;
      });
    },
    getList() {
      var flows = ["", "1621061241873154050"];
      var flows = [
        {
          id: "1611273939011809286",
          name: "日常保洁",
          name1: "保洁待办处理",
        },
        {
          id: "1637655498083803137",
          name: "巡查管理",
          name1: "巡查待办处理",
        },
        {
          id: "1627969124636323842",
          name: "应急管理",
          name1: "应急待办处理",
        },
        {
          id: "1620714615765766145",
          name: "高危作业",
          name1: "高危待办处理",
        },
        {
          id: "1621061241873154050",
          name: "小修管理",
          name1: "小修待办处理",
        },
      ];
      var d = new Date();
      var y = d.getFullYear();
      var m = d.getMonth();
      var s = new Date(y, m, 1).getTime();
      var e = new Date(y, m + 1, 1).getTime() - 1000;
      for (let i = 0; i < flows.length; i++) {
        this.axios({
          method: "post",
          url: this.axios.flow + "/flow/pendingList",
          data: {
            keyword: "",
            pageNumber: 1,
            pageSize: 1,
            startDate: s,
            endDate: e,
            flowId: flows[i].id,
          },
        }).then((res) => {
          this.$store.state.dots[flows[i].name] = res.data.data.total;
          this.$store.state.dots[flows[i].name1] = res.data.data.total;
        });
      }
    },
  },
  created() {
    this.getProperty();
    //this.localSocket();
  },
  destroyed() {
    //websock.close(); //离开路由之后断开websocket连接
    //this.alarms = [];
  },
  mounted() {
    setTimeout(() => {
      this.$refs.sysMenu.getMenu(axios);
      this.$refs.top.reachData(axios);
      this.getList();
    }, 500);
  },
};
</script>
<style lang="">
#reLink {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 2222;
  background: rgba(0, 0, 0, 0.3);
}
#reLinkson {
  margin: 100px auto;
  width: 300px;
  background: #fff;
  padding: 20px;
}
#reLinkson h2 {
  font-size: 18px;
  margin-bottom: 10px;
}
#reLinkson p {
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue